var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{attrs:{"type":"primary","disabled":_vm.disabled},on:{"click":_vm.handleClick}},[_vm._v("更新"+_vm._s(_vm.disabled ? _vm.times : null))])
}
var staticRenderFns = []

export { render, staticRenderFns }